import React from "react";

import clsx from "clsx";

import type { LabelProps } from "@busbud/horizon";
import { Label, IconGlobe } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { CustomNativeSelect } from "../custom-native-select";

interface PickerLanguageProps {
  size?: LabelProps["size"];
  className?: string;
}

export const PickerLanguage: React.FC<PickerLanguageProps> = ({
  size,
  className
}) => {
  const { translator, locale, locale_links } = useAppContext();

  const current_link = locale_links[locale];
  if (!current_link) {
    return null;
  }
  return (
    <div
      className={clsx("-mb-050 -mt-050 ml-0 mr-0 flex items-center", className)}
    >
      <CustomNativeSelect
        defaultValue={current_link.link}
        data-interactive="redirection"
        id="picker-language"
        Trigger={
          <Label
            fontWeight="bold"
            as="label"
            size={size}
            className="flex items-center"
            htmlFor="picker-language"
            iconStart={
              <IconGlobe size="md" className="mr-100 text-icon-color-primary" />
            }
          >
            {translator.t("!footer.language-selector")}
            <span className="font-weight-normal before:content-['\00A0\00A0\2014\00A0\00A0']">
              {current_link.label}
            </span>
          </Label>
        }
      >
        {Object.values(locale_links)
          .filter(loc => !loc.disabled)
          .map(loc => (
            <option key={loc.label} value={loc.link}>
              {loc.label}
            </option>
          ))}
      </CustomNativeSelect>
    </div>
  );
};
